import { Row, Col, Input, message } from "antd";
import { Scrollbars } from "react-custom-scrollbars";
import sortBy from "lodash/sortBy";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useWindowDimensions } from "../../../../lib/useViewport";
import ticSelect from "../../../../assets/images/tic.png";
import CancelArrow from "../../../../assets/images/cancelArrow.svg";
import Loyality from "../../../../assets/images/loyalityIcon.svg";
import UPI from "../../../../assets/images/upiIcon.svg";
import Gift from "../../../../assets/images/giftIcon.svg";
import Credit from "../../../../assets/images/creditCardIcon.svg";
import cardType from "../../../../assets/images/cardType.svg";
import giftVoucher from "../../../../assets/images/giftVoucher.svg";
import creditNote from "../../../../assets/images/creditNote.svg";
import walletWhite from "../../../../assets/images/walletWhite.png";
import styles from "../../../../constants/styles.json";
import messages from "../../../../errors/messages.en-IN.json";
import CWPoleDisplay from "../../../../lib/printer/CWPoleDisplay";
import PoleDisplay from "../../../../lib/printer/poleDisplay";
import useCartStore from "../../../../stores/useCartStore";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";
import useTransactionStore from "../../../../stores/useTransactionStore";

const SMPaymentBar = ({
  showPaymentMethods,
  showPayments,
  filteredPaymentMethods,
  posConfig,
  cart,
  tillData,
  currenciesList,
  selectedPaymentMethod,
  setSelectedPaymentMethod,
  amount,
  setAmount,
  setNumb,
  onChangeAmount,
  handleAmount,
  handleCashPayment,
  setOverPayedAmount,
  overPayedAmount,
  setIsCardPaymentFlag,
  isCardPaymentFlag,
  paymentModalInputRef,
  paymentCardRef,
  setIsInputFocused,
  setShowInputFields,
  setShowCardPaymnteModal,
  setPaymentType,
  setCardPaymnetError,
  walletFunc,
  verifyStock,
  processOrder,
  requestPayment,
  handlePayment,
  showConfirm,
  isOnline,
  isExchange,
  exchangeCart,
  customerConfigData,
  retailCustomerFields,
  pricePrecision,
  themeJSON,
  currenciesData,
  denaminationsKeyboard,
  setDenaminationsKeyboard,
  isShowingAll,
  showMoreItems,
  showPreviousItems,
  modulo,
  renderPaymentsData,
  CWHardwareController,
  setIsNewGiftCardFlag,
  setGiftCardMode,
  setIsBankTransferOpen,
  setBankTransferContext,
}) => {
  const { t } = useTranslation();
  const { width } = useWindowDimensions();

  return (
    <div
      data-zone="payment"
      data-zone-label="Payment"
      tabIndex={-1}
      style={{
        width: "81.5%",
        paddingTop: "1.5%",
        paddingBottom: "1.5%",
        display: !showPaymentMethods && "none",
      }}
    >
      <Row style={{ padding: "0 1% 0 3.5%", height: "18.5vh" }} gutter={5}>
        {sortBy(showPayments, "sequenceNo").map((pm, ind) => {
          if (
            (posConfig?.loyaltyApplicable === "N" && pm.name === "Loyalty") ||
            (!cart?.customer?.loyaltyLevel?.cwrLoyaltyLevelId && pm.name === "Loyalty") ||
            (!cart?.customer?.iscredit && pm.iscredit && useTransactionStore.getState().isCreditSale !== "true") ||
            pm.name.toLowerCase() === "cafe tips" ||
            (!cart?.customer?.cwrWallet?.wallet_Id && pm.isWallet === "Y")
          ) {
            return null;
          }
          return (
            <Col span={8} key={pm.finPaymentmethodId}>
              <button
                onClick={async () => {
                  const isExchangeFlow = useTransactionStore.getState().selectedReturnType === "EXCHANGE";
                  if (isExchangeFlow) {
                    const exchangeCartLocal = useCartStore.getState().exchangeCart || {};
                    const exchangeTotal = Number(exchangeCartLocal?.total) || 0;
                    const returnTotal = Math.abs(Number(cart?.total) || 0);
                    if (exchangeTotal < returnTotal) {
                      message.warning("Exchange value must be equal to or greater than Return value.");
                      return;
                    }
                  }
                  const panRule = customerConfigData?.conditionalRules?.find((rule) => rule.action === "Request PAN");
                  const activeCartForPan = isExchangeFlow ? useCartStore.getState().exchangeCart || cart : cart;
                  const isPanMandatoryNow = panRule && Number(activeCartForPan?.total) > Number(panRule.value);
                  const enteredPAN = activeCartForPan?.customer?.panCard || activeCartForPan?.customer?.metaData?.find((m) => m.key?.toLowerCase().startsWith("pan"))?.value;
                  if (retailCustomerFields && retailCustomerFields.length > 0 && isPanMandatoryNow && (!enteredPAN || enteredPAN.trim() === "")) {
                    const checkPanValidation = await verifyStock();
                    if (!checkPanValidation) {
                      return;
                    }
                  }
                  if (cart.items.length > 0 && pm.name !== "Complete Order") {
                    setNumb(0);
                    let orderTimeDetails = usePOSConfigStore.getState().orderTimeDetails || {
                      orderStartTime: "",
                      orderEndTime: "",
                      paymentStartTime: "",
                    };
                    if (orderTimeDetails.paymentStartTime === "") {
                      orderTimeDetails = {
                        ...orderTimeDetails,
                        paymentStartTime: dayjs(new Date()).format("DD-MM-YYYY HH:mm:ss"),
                      };
                      usePOSConfigStore.getState().setOrderTimeDetails(orderTimeDetails);
                    }
                    if (pm.isWallet === "Y") {
                      walletFunc();
                    }
                    if (pm.name.toLowerCase() === "card" && !pm.integratedPayment && posConfig?.enablePaymentData === "Y" && posConfig?.show_card_payment_popup !== "Y") {
                      setIsCardPaymentFlag(true);
                    }
                    if (pm.isBankTransfer === "Y" || pm.name?.toLowerCase() === "bank transfer") {
                      if (setIsBankTransferOpen && setBankTransferContext) {
                        setBankTransferContext({ type: "payment", paymentMethod: pm });
                        setIsBankTransferOpen(true);
                      } else {
                        setIsCardPaymentFlag(true);
                      }
                    }
                    const currenciesListLocal = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                    const precision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;

                    const isExchangeFlow = useTransactionStore.getState().selectedReturnType === "EXCHANGE";
                    const exchangeCartLocal = isExchangeFlow ? useCartStore.getState().exchangeCart || {} : null;
                    let originalAmount = isExchangeFlow
                      ? Math.abs((exchangeCartLocal.total || 0) + (cart.total || 0)) - (exchangeCartLocal.paid || 0)
                      : Math.abs(cart.total) - (cart.paid ?? 0);

                    // Get the smallest denomination (assuming sorted list)
                    const smallestDenomination = currenciesListLocal.length > 0 ? currenciesListLocal[0].value : 1;

                    // Round the amount to the nearest multiple of the smallest denomination
                    let roundedAmount = Math.ceil(originalAmount / smallestDenomination) * smallestDenomination;

                    // Calculate overpayment
                    let overpayment = (roundedAmount - originalAmount).toFixed(precision);
                    setOverPayedAmount(pm.roundOffForPos === "Y" && pm.integratedPayment === false ? overpayment : 0);
                    // setAmount(
                    //   pm.roundOffForPos === "Y" && pm.integratedPayment === false ? roundedAmount.toFixed(precision) : parseFloat(originalAmount).toFixed(precision)
                    // );
                    if (selectedPaymentMethod?.finPaymentmethodId !== pm.finPaymentmethodId) {
                      setAmount(
                        pm.roundOffForPos === "Y" && pm.integratedPayment === false && !isExchangeFlow
                          ? roundedAmount.toFixed(precision)
                          : parseFloat(originalAmount).toFixed(precision)
                      );
                    }
                    setSelectedPaymentMethod(pm);
                    paymentModalInputRef?.current?.focus();
                    setTimeout(() => {
                      paymentModalInputRef?.current?.select();
                    }, 50);
                  } else if (pm.name === "Complete Order" && cart.paid >= cart.total) {
                    processOrder();
                  }
                  setShowInputFields(false);
                }}
                id={`sm-payment-${pm.name.toLowerCase()}`}
                ref={ind === 0 ? paymentCardRef : null}
                style={{
                  backgroundColor: pm.name === "Complete Order" ? "#2F3856" : themeJSON.paymentMethodsBGColor || "#046307C2",
                  border: `1px solid ${themeJSON.paymentMethodsBGColor || "#fff"}`,
                  borderRadius: "7px",
                  height: "8.6vh",
                  width: "100%",
                  cursor: "pointer",
                }}
                tabIndex={0}
                onKeyPress={(e) => (e.charCode === 13 ? setSelectedPaymentMethod(pm) : null)}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "row",
                    position: "relative",
                    fontSize: "1vw",
                  }}
                >
                  {pm.finPaymentmethodId === selectedPaymentMethod.finPaymentmethodId ? (
                    <img
                      src={ticSelect}
                      style={{
                        top: "-2vh",
                        right: "0",
                        height: "2.1vh",
                        position: "absolute",
                      }}
                    />
                  ) : null}
                  <span className="payment" style={{ color: "#fff", fontSize: "1em" }}>
                    {pm.name.toLowerCase() === "cash" ? (
                      <>
                        {currenciesList[0] ? currenciesList[0].currSymbol : ""}
                        &nbsp;{pm.name}
                      </>
                    ) : pm.name.toLowerCase() === "card" ? (
                      <>
                        <img src={cardType} style={{ height: "2.5vh" }} color={"#fff"} />
                        &nbsp;{pm.name}
                      </>
                    ) : pm.name.toLowerCase() === "upi" ? (
                      <>
                        <img src={UPI} style={{ height: "2.5vh" }} color={"#fff"} />
                        &nbsp;{pm.name}
                      </>
                    ) : pm.iscredit ? (
                      <>
                        <img src={Credit} style={{ height: "2.5vh" }} color={"#fff"} />
                        &nbsp;{pm.name}
                      </>
                    ) : pm.name.toLowerCase() === "loyalty" ? (
                      <>
                        <img
                          src={Loyality}
                          style={{
                            height: "2.5vh",
                            left: "0.5em",
                          }}
                          color={"#fff"}
                        />
                        &nbsp;{pm.name}
                      </>
                    ) : pm.name.toLowerCase() === "gift card" ? (
                      <>
                        <img
                          src={Gift}
                          style={{
                            height: "2.5vh",
                            marginBottom: "0.2em",
                          }}
                          color={"#fff"}
                        />
                        &nbsp;{pm.name}
                      </>
                    ) : pm.name.toLowerCase() === "voucher" ? (
                      <>
                        <img
                          src={giftVoucher}
                          style={{
                            height: "2.5vh",
                            marginBottom: "0.2em",
                          }}
                          color={"#fff"}
                        />
                        &nbsp;{pm.name}
                      </>
                    ) : pm.name.toLowerCase() === "credit note" ? (
                      <>
                        <img src={creditNote} style={{ height: "2.5vh" }} color={"#fff"} />
                        &nbsp;{pm.name}
                      </>
                    ) : pm.isWallet === "Y" ? (
                      <>
                        <img
                          src={walletWhite}
                          style={{
                            height: "2.5vh",
                            marginBottom: "0.2em",
                          }}
                          color={"#fff"}
                        />
                        &nbsp;{pm.name}
                      </>
                    ) : (
                      <>{pm.name}</>
                    )}
                  </span>
                </div>
              </button>
            </Col>
          );
        })}

        {cart?.layAway === "Y" && posConfig?.advanceLayaway === "Y" && cart?.preOrder !== "Y" && posConfig?.enablePreOrder !== "Y" ? (
          <Col
            span={8}
            onClick={() => {
              if (posConfig?.requirePaymentForAdvance === "Y" && cart.paid <= 0) {
                message.warning(`${messages.warnings.payment.payment_required}`);
                return;
              }
              if (cart.paid <= cart.total) {
                cart.statusType = "layAway";
                useCartStore.getState().setCart(cart);
                const filtredCurrencies = tillData?.tillAccess?.csBunit?.currencies[0]?.denominations?.sort((a, b) => a.value - b.value) || [];
                const result = modulo(parseFloat(amount), filtredCurrencies[0]?.value);

                const isCashPayment = selectedPaymentMethod?.name?.toLowerCase() === "cash";
                const isValidCashAmount = parseFloat(amount) % 0.25 === 0;

                if (cart?.advancePayment > 0 && parseFloat(Math.abs(cart.total)) > parseFloat(cart.paid)) {
                  if (result !== 0 && isCashPayment) {
                    message.warning(`${t("cash_payment_error")}`);
                  } else {
                    processOrder("layaway");
                  }
                } else {
                  processOrder("layaway");
                }
              }
            }}
          >
            <button
              style={{
                backgroundColor: "#2F3856",
                border: "1px solid #fff",
                borderRadius: "7px",
                height: "8.6vh",
                width: "100%",
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "row",
                  color: "#fff",
                }}
              >
                Create Advance
              </div>
            </button>
          </Col>
        ) : null}

        {cart?.creditSale === "Y" ? (
          <Col
            span={8}
            onClick={() => {
              processOrder("layaway");
            }}
          >
            <button
              style={{
                backgroundColor: "#2F3856",
                border: "1px solid #fff",
                borderRadius: "7px",
                height: "8.6vh",
                width: "100%",
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "row",
                  color: "#fff",
                  fontSize: "1vw",
                }}
              >
                Credit Sale
              </div>
            </button>
          </Col>
        ) : null}

        {showPayments.length < filteredPaymentMethods.length && (
          <Col span={8}>
            <button
              onClick={isShowingAll ? showPreviousItems : showMoreItems}
              style={{
                backgroundColor: "#046307C2",
                border: "1px solid #fff",
                borderRadius: "7px",
                height: "8.6vh",
                width: "100%",
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "row",
                }}
              >
                <img style={{ height: "2.5vh", left: "0.5em" }} color={"#fff"} />
                <span className="payment" style={{ color: "#fff", marginLeft: "0.25em" }}>
                  ...
                </span>
              </div>
            </button>
          </Col>
        )}
      </Row>
      <div
        style={{
          background: "#fff",
          height: "23vh",
          width: "95%",
          margin: "0.75% 1% 2.7% 3.5%",
          border: "1px solid #fff",
          borderRadius: "7px",
        }}
      >
        <Row
          style={{
            height: "3vh",
            marginTop: "3%",
            fontSize: "1vw",
          }}
        >
          <Col span={12} style={styles.screenStyles.mainScreen.card}>
            <p style={{ margin: "0" }}>Amount Tendered</p>
          </Col>
          <Col
            span={12}
            style={{
              display: "flex",
              alignItems: "center",
              paddingRight: "1vw",
              textAlign: "right",
              justifyContent: "end",
            }}
          >
            <p
              style={{
                textAlign: "right",
                margin: "0",
                fontWeight: "500",
                color: "#0F0718",
                fontSize: "1em",
              }}
            >
              {/* {parseFloat(cart.total).toFixed(pricePrecision)} */}
              {(() => {
                const isExchangeMode = useTransactionStore.getState().selectedReturnType === "EXCHANGE";
                if (isExchangeMode) {
                  const exchangeCartData = useCartStore.getState().exchangeCart || {};
                  return parseFloat(exchangeCartData?.paid || 0).toFixed(pricePrecision);
                }
                return parseFloat(cart.total).toFixed(pricePrecision);
              })()}
            </p>
          </Col>
        </Row>

        <Row style={{ height: "3vh", fontSize: "1vw" }}>
          <Col span={12} style={styles.screenStyles.mainScreen.card}>
            <p style={{ margin: "0" }}>Change</p>
          </Col>
          <Col
            span={12}
            style={{
              display: "flex",
              alignItems: "center",
              paddingRight: "1vw",
              textAlign: "right",
              justifyContent: "end",
            }}
          >
            <p
              style={{
                textAlign: "right",
                margin: "0",
                fontWeight: "500",
                color: "#0F0718",
                fontSize: "1em",
              }}
            >
              {(cart.paid ?? 0) + parseFloat(amount) - Math.abs(cart.total) > 0
                ? ((cart.paid ?? 0) + parseFloat(amount) - Math.abs(Math.abs(cart.total) + Math.abs(overPayedAmount))).toFixed(pricePrecision)
                : cart?.change <= 0
                  ? "0.00"
                  : cart?.change}
            </p>
          </Col>
        </Row>

        <Row style={{ height: "3vh", fontSize: "1vw" }}>
          <Col span={12} style={styles.screenStyles.mainScreen.card}>
            <p style={{ margin: "0" }}>Overpayment</p>
          </Col>
          <Col
            span={12}
            style={{
              display: "flex",
              alignItems: "center",
              paddingRight: "1vw",
              textAlign: "right",
              justifyContent: "end",
            }}
          >
            <p
              style={{
                textAlign: "right",
                margin: "0",
                fontWeight: "500",
                color: "#0F0718",
                fontSize: "1em",
              }}
            >
              {Math.abs(overPayedAmount).toFixed(pricePrecision)}
            </p>
          </Col>
        </Row>

        <Row style={{ height: "3vh", fontSize: "1vw" }}>
          <Col span={12} style={styles.screenStyles.mainScreen.card}>
            <p style={{ margin: "0" }}>Remaining Due</p>
          </Col>
          <Col
            span={12}
            style={{
              display: "flex",
              alignItems: "center",
              paddingRight: "1vw",
              textAlign: "right",
              justifyContent: "end",
            }}
          >
            <p
              style={{
                textAlign: "right",
                margin: "0",
                fontWeight: "500",
                color: "#0F0718",
                fontSize: "1em",
              }}
            >
              {/* {parseFloat(Math.abs(cart.total)) >= parseFloat(cart.paid) ? parseFloat(Math.abs(cart.total) - cart.paid).toFixed(pricePrecision) : 0} */}
              {(() => {
                const effectiveTotal = isExchange
                  ? Math.abs(((useCartStore.getState().exchangeCart || {})?.total || 0) + (cart?.total || 0)) // net of exchange + return
                  : Math.abs(cart.total);
                const effectivePaid = isExchange ? (useCartStore.getState().exchangeCart || {})?.paid || 0 : cart.paid;
                return effectiveTotal >= effectivePaid ? parseFloat(effectiveTotal - effectivePaid).toFixed(pricePrecision) : 0;
              })()}
            </p>
          </Col>
        </Row>
        <hr style={{ margin: "1vh 1vw" }} />
        <Scrollbars style={{ height: "6.3vh" }}>
          {cart?.advancePayment > 0 &&
            (cart.layAway === "Y" || cart.creditSale === "Y") &&
            cart?.paymentData?.map((item, idx) => {
              return (
                <Row key={item.name || idx} style={{ fontSize: "1vw" }}>
                  <Col
                    span={12}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "0.8vw",
                      fontWeight: "450",
                      textAlign: "left",
                    }}
                  >
                    <p style={{ margin: "0" }}>{item.name.toLowerCase() === "card" && item.authorizationCode ? `${item.name} - ${item.authorizationCode}` : item.name}</p>
                  </Col>
                  <Col
                    span={12}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingRight: "1vw",
                      textAlign: "right",
                      justifyContent: "end",
                    }}
                  >
                    {/* {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                            &nbsp; */}
                    <p
                      style={{
                        textAlign: "right",
                        margin: "0",
                        fontWeight: "500",
                        paddingRight: "1.2vw",
                      }}
                    >
                      {" "}
                      {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                      &nbsp;{parseFloat(item.amount).toFixed(pricePrecision)} {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                    </p>
                  </Col>
                </Row>
              );
            })}
          {renderPaymentsData()}
        </Scrollbars>
      </div>
      <Row style={{ margin: "0 0 0 0 " }}>
        <Input
          className="productSearch sm-payment-search totalInput"
          style={{
            borderRadius: "0.5vw",
            height: "7.3vh",
            margin: "0 1% 2.7% 3.5%",
            borderRadius: "5px",
            textAlign: "right",
            fontWeight: "500",
            fontSize: "2.5em",
            borderColor: "#fff",
            color: "#2F3856",
          }}
          // prefix={<span style={{ color: "#0F0718", fontWeight: "600" }}>Amount Tendered</span>}
          value={amount}
          // type="number"
          id="sm-total-amount-input"
          onChange={onChangeAmount}
          placeholder="Enter Amount"
          ref={paymentModalInputRef}
          onFocus={() => {
            setIsInputFocused(true);
          }}
          onBlur={() => {
            setIsInputFocused(false);
          }}
          readOnly={cart.items.length > 0 ? false : true}
          disabled={tillData.tillAccess.cwrTill.layAway === "Y" && tillData.tillAccess.cwrTill.payNow === "N" ? true : false}
          onPressEnter={() =>
            handlePayment({
              selectedPaymentMethod,
              cart,
              amount,
              posConfig,
              tillData,
              isOnline,
              isExchange,
              showConfirm,
              requestPayment,
              processOrder,
              setShowCardPaymnteModal,
              setPaymentType,
              setCardPaymnetError,
              messages,
              isCardPaymentFlag,
              enableGiftCardCheck: false,
              enablePoleDisplay: false,
              enableSetNumb: false,
            })
          }
        />
      </Row>
      {denaminationsKeyboard && selectedPaymentMethod?.name?.toLowerCase() === "cash" ? (
        <Row style={{ padding: "0 1% 0 3.5%" }}>
          <Col span={18}>
            <Row gutter={[8, 5]} style={{ display: "flex", flexDirection: "row-reverse" }}>
              {currenciesData.map((currency, index) => (
                <Col span={8} key={currency.id || `curr-${index}`}>
                  <button
                    id={`sm-amount-button${currenciesData.indexOf(currency) + 1}`}
                    className="amt-dial-btn-market"
                    onClick={() => handleCashPayment(currency.value)}
                    disabled={currency.value === 999999}
                    style={{
                      color: currency.value !== 999999 ? "#0f0718" : "transparent",
                    }}
                  >
                    {currency.value}
                  </button>
                </Col>
              ))}
            </Row>
          </Col>

          <Col span={6}>
            <Row style={{ padding: "0 0 7% 7%" }}>
              <button
                className="amt-dial-btn-market"
                id="sm-amount-buttonRemove"
                onClick={() => handleAmount("x")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={CancelArrow}
                  alt="back space"
                  style={{
                    width: "1.4vw",
                    height: "1.4vw",
                    objectFit: "contain",
                  }}
                />
              </button>
            </Row>
            <Row style={{ padding: "0 0 7% 7%" }}>
              <button id="sm-amount-buttonClear" className="amt-dial-btn-market" onClick={() => setDenaminationsKeyboard(!denaminationsKeyboard)}>
                1,2,3...
              </button>
            </Row>
            <Row style={{ padding: "0 0 0 7%" }}>
              <button
                id="sm-amount-buttonEnter"
                className="amt-dial-btn-market2"
                onClick={() =>
                  handlePayment({
                    selectedPaymentMethod,
                    cart,
                    amount,
                    posConfig,
                    tillData,
                    isOnline,
                    isExchange,
                    showConfirm,
                    requestPayment,
                    processOrder,
                    setShowCardPaymnteModal,
                    setPaymentType,
                    setCardPaymnetError,
                    messages,
                    enableGiftCardCheck: true,
                    enablePoleDisplay: true,
                    CWHardwareController,
                    CWPoleDisplay,
                    PoleDisplay,
                  })
                }
              >
                Enter
              </button>
            </Row>
          </Col>
        </Row>
      ) : (
        <Row style={{ padding: "0 1% 0 3.5%" }} gutter={[8, 6]}>
          <Col span={6}>
            <button id="sm-amount-button1" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("1")}>
              1
            </button>
          </Col>
          <Col span={6}>
            <button id="sm-amount-button2" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("2")}>
              2
            </button>
          </Col>
          <Col span={6}>
            <button id="sm-amount-button3" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("3")}>
              3
            </button>
          </Col>
          <Col span={6}>
            <button
              className="amt-dial-btn-market"
              id="sm-amount-buttonRemove"
              onClick={() => handleAmount("x")}
              style={{
                background: themeJSON?.keyBoardColor,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={CancelArrow}
                alt="back space"
                style={{
                  width: "1.4vw",
                  height: "1.4vw",
                  objectFit: "contain",
                }}
              />
            </button>
          </Col>
          <Col span={6}>
            <button id="sm-amount-button4" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("4")}>
              4
            </button>
          </Col>
          <Col span={6}>
            <button id="sm-amount-button5" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("5")}>
              5
            </button>
          </Col>
          <Col span={6}>
            <button id="sm-amount-button6" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("6")}>
              6
            </button>
          </Col>
          <Col span={6}>
            <button
              id="sm-amount-buttonClear"
              className="amt-dial-btn-market"
              style={{ background: themeJSON?.keyBoardColor }}
              onClick={() => setDenaminationsKeyboard(!denaminationsKeyboard)}
            >
              1,2,3...
            </button>
          </Col>
          <Col span={18}>
            <Row gutter={[8, 6]}>
              <Col span={8}>
                <button id="sm-amount-button7" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("7")}>
                  7
                </button>
              </Col>
              <Col span={8}>
                <button id="sm-amount-button8" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("8")}>
                  8
                </button>
              </Col>
              <Col span={8}>
                <button id="sm-amount-button0" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("9")}>
                  9
                </button>
              </Col>
              <Col span={8}>
                <button id="sm-amount-button0" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("0")}>
                  0
                </button>
              </Col>
              <Col span={8}>
                <button id="sm-amount-button00" className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount("00")}>
                  00
                </button>
              </Col>
              <Col span={8}>
                <button id="sm-amount-button." className="amt-dial-btn-market" style={{ background: themeJSON?.keyBoardColor }} onClick={() => handleAmount(".")}>
                  .
                </button>
              </Col>
            </Row>
          </Col>
          <Col span={6}>
            <button
              id="sm-amount-buttonEnter"
              className="amt-dial-btn-market2"
              style={{ background: themeJSON?.keyBoardColor }}
              onClick={() =>
                handlePayment({
                  selectedPaymentMethod,
                  cart,
                  amount,
                  posConfig,
                  tillData,
                  isOnline,
                  isExchange,
                  showConfirm,
                  requestPayment,
                  processOrder,
                  setShowCardPaymnteModal,
                  setPaymentType,
                  setCardPaymnetError,
                  messages,
                  t,
                  enableGiftCardCheck: true,
                  enablePoleDisplay: false,
                  enableSetNumb: true,
                  setNumb,
                })
              }
            >
              Enter
            </button>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default SMPaymentBar;
